import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-left">
          <p className="hero-eyebrow">
            <svg className="hero-eyebrow-pin" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5Z" />
            </svg>
            Serving the Kansas City Metro
          </p>

          <h1 className="hero-headline">
            <span className="hero-headline-text">Disco Duck Events</span>
          </h1>

          <img
            src="/DiscoDuckLogo.png"
            alt="Disco Duck Events"
            width="600"
            height="750"
            className="hero-logo-mobile"
          />

          <p className="hero-subtitle hero-subtitle--desktop">
            A handmade wooden booth with a professional DSLR camera &mdash; so the photos your guests take home actually look good. Open-air setup, prints on the spot, and instant sharing to their phones.
          </p>
          <p className="hero-subtitle hero-subtitle--mobile">
            Stunning photo quality, professional prints and instant sharing, <strong>our Photo Booth is the ultimate event highlight!</strong>
          </p>

          <img
            src="/ring_photobooth_image.webp"
            width="1800"
            height="1200"
            alt="Three guests laughing and pointing at a &quot;He put a ring on it&quot; sign"
            className="hero-photo-mobile"
            loading="eager"
            decoding="async"
          />

          <div className="hero-cta-group">
            <Link to="/contact" className="hero-cta hero-cta-primary" data-track="hero">
              Check Availability
            </Link>
            <a
              href="https://fotoshare.co/e/S3vH9oxpzOewNSc4GBLt4"
              className="hero-cta hero-cta-secondary"
              data-track="hero"
              data-track-label="Explore Gallery"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="hero-cta-label--desktop">Explore Gallery</span>
              <span className="hero-cta-label--mobile">View Gallery</span>
            </a>
          </div>
          <p className="cta-reassurance">Packages from $450 &middot; No commitment</p>
        </div>

        <div className="hero-right">
          <img
            src="/ring_photobooth_image.webp"
            width="1800"
            height="1200"
            alt="Three guests laughing and pointing at a &quot;He put a ring on it&quot; sign"
            className="hero-right-image"
            loading="eager"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
